/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AbstractStepDTO } from './abstractStepDTO';
import { EmailLandingPageLink } from './emailLandingPageLink';

export interface EmailStepDTO extends AbstractStepDTO { 
    emailTemplateId: string;
    languageMode: EmailStepDTO.LanguageModeEnum;
    fixedLanguage?: string;
    defaultLanguage?: string;
    affiliateMode: EmailStepDTO.AffiliateModeEnum;
    fixedAffiliateCode?: string;
    defaultAffiliateCode?: string;
    landingPageLinks?: Array<EmailLandingPageLink>;
}
export namespace EmailStepDTO {
    export type LanguageModeEnum = 'FIXED' | 'FROM_CONTACT' | 'DEFAULT';
    export const LanguageModeEnum = {
        FIXED: 'FIXED' as LanguageModeEnum,
        FROMCONTACT: 'FROM_CONTACT' as LanguageModeEnum,
        DEFAULT: 'DEFAULT' as LanguageModeEnum
    };
    export type AffiliateModeEnum = 'FIXED' | 'FROM_DATA' | 'DEFAULT';
    export const AffiliateModeEnum = {
        FIXED: 'FIXED' as AffiliateModeEnum,
        FROMDATA: 'FROM_DATA' as AffiliateModeEnum,
        DEFAULT: 'DEFAULT' as AffiliateModeEnum
    };
}